/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';

import {Consumers as AppContextConsumers, Providers as AppContextProviders} from 'common/util/react';
import {BrowserContextRoot} from 'common/widgets/browser-context-root';
import {CurrentProjectConsumer, CurrentProjectProvider} from 'common/contexts/react/current-project-context';
import {CurrentUserConsumer, CurrentUserProvider} from 'common/contexts/react/current-user-context';

import {AppContext} from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AppContextProvider = ({children}) => {
  const {currentProject, currentUser} = document
    .querySelector<BrowserContextRoot>(`mp-browser-context-root`)
    .getConfig(`defaultContexts`);

  const providers = [<CurrentProjectProvider value={currentProject} />, <CurrentUserProvider value={currentUser} />];
  return (
    <AppContextProviders providers={providers}>
      {/* @ts-ignore */}
      <AppContextConsumers consumers={[CurrentProjectConsumer, CurrentUserConsumer] as const}>
        {([currentProject, currentUser]) => (
          /** @ts-ignore */
          <AppContext.Provider value={{currentProject, currentUser}}>{children}</AppContext.Provider>
        )}
      </AppContextConsumers>
    </AppContextProviders>
  );
};
